export default selectFilter => {
    //console.log('selectFilter');

    function goTo(event) {
        const goto = event.target.options[event.target.selectedIndex].getAttribute('data-goto');
        const value = event.target.options[event.target.selectedIndex].value;
        //console.log('goto', goto);
        //console.log('value', value);

        if (goto !== null) {
            let headerSticky = document.querySelector('.main-header.sticky');
            let headerStickyHeight = typeof(headerSticky) != 'undefined' && headerSticky != null ? headerSticky.offsetHeight : document.querySelector('.main-header').offsetHeight;

            let section = document.getElementById(goto);
            let offset = section.getBoundingClientRect().top + window.pageYOffset - headerStickyHeight;

            window.scrollTo({top: offset, behavior: 'smooth'});
        }

        if (value !== '') {
            window.location = value;
        }
    }

    selectFilter.addEventListener('change', goTo);
};
